import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import Seo from "../../components/Seo";

const NAV = [
  { to: "/admin", label: "Dashboard", end: true, testid: "admin-nav-dashboard" },
  { to: "/admin/launch", label: "Launch Control", testid: "admin-nav-launch" },
  { to: "/admin/products", label: "Products", testid: "admin-nav-products" },
  { to: "/admin/backups", label: "Catalog Backup", testid: "admin-nav-backups" },
  { to: "/admin/orders", label: "Orders", testid: "admin-nav-orders" },
  { to: "/admin/categories", label: "Categories", testid: "admin-nav-categories" },
  { to: "/admin/customers", label: "Customers", testid: "admin-nav-customers" },
  { to: "/admin/homepage", label: "Home Page", testid: "admin-nav-homepage" },
  { to: "/admin/settings", label: "Website", testid: "admin-nav-settings" },
  { to: "/admin/account", label: "Admin Account", testid: "admin-nav-account" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="admin-shell">
      <Seo title="Studio Admin" description="Private Lalita Soujanya administration area." robots="noindex, nofollow" />
      <aside className="admin-sidebar" data-testid="admin-sidebar">
        <div className="admin-brand">
          <span className="eyebrow">Studio</span>
          <strong>LALITA SOUJANYA</strong>
        </div>
        <nav>
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={n.testid}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="admin-user">
          <div>
            <span className="eyebrow">Signed in</span>
            <strong data-testid="admin-user-email">{user?.email}</strong>
          </div>
          <button onClick={handleLogout} data-testid="admin-logout-button" aria-label="Sign out">
            <LogOut size={16} />
          </button>
        </div>
      </aside>
      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  );
}
